<template>
  <div id="contact">
    <div class="hero is-primary">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title">{{ $t('contact.title') }}</h1>
        </div>
      </div>
    </div>

    <section class="section">
      <form novalidate @submit.prevent="validateForm()" class="form" v-if="!formSubmitted">
        <div class="container">
          <div class="field">
            <p class="control">
              <input type="text" class="input is-primary is-medium" :class="{ 'is-danger': errors.has('name') }" name="name" :placeholder="$t('common.name')" v-validate="'required'" v-model="name">
            </p>
            <p class="help is-danger" v-show="errors.has('name')">{{ errors.first('name') }}</p>
          </div>

          <div class="field">
            <p class="control">
              <input type="text" class="input is-primary is-medium" :class="{ 'is-danger': errors.has('email') }" name="email" :placeholder="$t('common.email')" v-validate="'email|required'" v-model="email">
            </p>
            <p class="help is-danger" v-show="errors.has('email')">{{ errors.first('email') }}</p>
          </div>

          <div class="field">
            <p class="control">
              <input type="text" name="subject" :placeholder="$t('common.subject')" class="input is-primary is-medium" :class="{ 'is-danger': errors.has('subject') }" v-validate="'required'" v-model="subject">
            </p>
            <p class="help is-danger" v-show="errors.has('subject')">{{ errors.first('subject') }}</p>
          </div>

          <div class="field">
            <p class="control">
              <textarea name="message" :placeholder="$t('common.message')" class="textarea is-primary is-medium" :class="{ 'is-danger': errors.has('message') }" v-validate="'required'" v-model="message"></textarea>
            </p>
            <p class="help is-danger" v-show="errors.has('message')">{{ errors.first('message') }}</p>
          </div>

          <div class="field">
            <p class="control">
              <button type="submit" class="button is-primary is-fullwidth" :class="{ 'is-loading': isLoading }">
                {{ $t('common.send') }}
              </button>
            </p>
          </div>
        </div>
      </form>
      <div v-else>
        <div class="message is-primary" v-if="!sendEmailError">
          <div class="message-body">
            {{ $t('contact.success') }}
          </div>
        </div>
        <div class="message is-danger" v-if="sendEmailError">
          <div class="message-body">
            {{ $t('contact.error') }}
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      name: '',
      email: '',
      subject: '',
      message: '',

      isLoading: false,
      formSubmitted: false,
      sendEmailError: false
    }
  },
  metaInfo () {
    return {
      title: this.$t('contact.title'),

      meta: [
        { name: 'description', content: this.$t('contact.description') }
      ]
    }
  },
  methods: {
    validateForm: function () {
      this.$validator.validateAll()

      if (!this.errors.any()) {
        this.sendEmail()
      }
    },
    sendEmail: function () {
      this.isLoading = true
      this.$http.post('contact/submit', { from: this.email, name: this.name, subject: this.subject, text: this.message })
        .then(() => {
          this.formSubmitted = true
          this.sendEmailError = false
        })
        .catch((error) => {
          this.formSubmitted = true
          this.sendEmailError = true

          console.log(error)
        })
    }
  }
}
</script>



<style lang="scss" scoped>
  .input,
  .textarea {
    background: transparent;
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?536a87d6